import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TicketDto } from 'src/app/models/Tickets/TicketDto';
import { TicketService } from 'src/app/services/tickets.service';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
declare var bootstrap: any;

@Component({
    selector: 'app-create-ticket-form',
    templateUrl: './create-ticket-form.component.html',
    styleUrl: './create-ticket-form.component.css',
    imports: [CommonModule, FormsModule]
})
export class CreateTicketFormComponent {
  @Input() isEditing: boolean = false;
  @Input() iccid?: string = '';
  @Input() errorMessage?: string = '';
  @Output() handleCreateUpdateResponse = new EventEmitter<string>();

  description: string = '';

  /**
   *
   */
  constructor(private ticketService: TicketService) {

  }

  createTicket() {

    const request = {
      iccid: this.iccid,
      error: this.errorMessage,
      description: this.description
    } as TicketDto;


    this.ticketService.createTicket(request).subscribe(
      response => {
        this.clearForm();
        this.handleCreateUpdateResponse.emit(response.validationErrorMessage as string);


      },
      error => {
        this.clearForm();
        this.handleCreateUpdateResponse.emit('Error creating ticket: ' + error);
      }
    );


  }

  clearForm() {
    this.description = '';
  }


  updateTicket() {
    // Lógica para crear el ticket(page: number) {

  }

}
